/**
 * Use Reject Suggested Document Hook
 *
 * Wraps the rejectSuggestedDocument mutation using useApiMutation
 * for consistent error handling.
 */

import { useTranslation } from "react-i18next";
import { api } from "convex/_generated/api";
import { useApiMutation } from "@/packages/features-shared";
import type { Id } from "@/packages/types";

export function useRejectSuggestedDocument() {
  const { t } = useTranslation("audits");
  const mutation = useApiMutation(
    api.checklist_mutations.rejectSuggestedDocument,
    {
      name: "reject-suggested-document",
      successMessage: t("suggestions.successDismiss"),
    },
  );

  return (args: {
    documentId: Id<"documents">;
    checklistItemId: Id<"checklistItems">;
  }) => mutation.mutateAsync(args);
}
